import styled from 'styled-components';

export const Load = styled.div`
  z-index: -999;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 70px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
